'use client';

import { Provider } from 'react-redux';
import { injectStore } from '@/services/setupInterceptors';
import { store } from './store';

injectStore(store);

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
